<template>
  <div class="rl-map">
    <div slot="header">
      <div>
        <!-- <template> -->
        <!--            <el-select v-model="queryInfo.status" placeholder="请选择车辆状态" style="margin-left: 20px" @change="updateMaker">-->
        <!--              <el-option-->
        <!--                v-for="item in bikechange"-->
        <!--                :key="item.value"-->
        <!--                :label="item.label"-->
        <!--                :value="item.value"-->
        <!--              >-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!-- <el-select v-model="queryInfo.statustype" placeholder="请选择查询方式" style="margin-left: 20px"
                       @change="updateMaker">
              <el-option
                v-for="item in bikechangestatustype"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select v-model="queryInfo.hour" placeholder="请选择查询时间段" style="margin-left: 20px" @change="updateMaker"
                       v-if="this.queryInfo.statustype === 0">
              <el-option
                v-for="item in bikechangehour"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template> -->
        <template>
          <div class="map-type">
            <el-radio v-model="mapchange" label="1">{{ $t('operate.name73') }}</el-radio>
            <el-radio v-model="mapchange" label="2">{{ $t('operate.name74') }}</el-radio>
          </div>
        </template>
      </div>
    </div>
    <template>
      <div v-if="mapchange === '1'" class="bm-view google-map-wrap">
        <heat-map
          ref="googleHeatMap"
          :interactive="true"
          :auto-fit-bounds="true"
          :initialZoom="8"
          :points="hotmarkersgoole"
          :lat="centergoole.lat"
          :lng="centergoole.lng"
          height="100%"
          @ready="onGoogleHeatMapReady"
        />
        <!-- 对齐实时监控：Google 默认 UI 关闭后补 +/- -->
        <div class="map-zoom-controls">
          <button type="button" class="map-zoom-btn" @click="changeMapZoom(1)">+</button>
          <button type="button" class="map-zoom-btn" @click="changeMapZoom(-1)">−</button>
        </div>
      </div>
      <div v-if="mapchange === '2'" class="tdt-map-wrap">
        <div id="dataOverviewMapDiv" class="bm-view"></div>
        <div class="map-zoom-controls">
          <button type="button" class="map-zoom-btn" @click="changeMapZoom(1)">+</button>
          <button type="button" class="map-zoom-btn" @click="changeMapZoom(-1)">−</button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
// import GmapCluster from 'vue2-google-maps/src/components/cluster'
// import { BmlHeatmap } from 'vue-baidu-map'
import HeatMap from '@/components/HeatMap'
import { computeDenseClusterView } from '@/utils/heatmapViewBounds'
import { toMapLngLat } from '@/utils/mapCoords'
import { getEbikeMap } from '@/api/home.js'
import { defaultMapChange } from '@/config/flavor'
import { escapeHtml } from '@/utils/htmlEscape'

const DEFAULT_MAP_CENTER = { lng: 116.4074, lat: 39.9042 }
export default {
  components: {
    HeatMap
    // GmapCluster,
    // BmlHeatmap
    // BmlMarkerClusterer
  },
  props: {
    tenantType: {
      type: String,
      default: () => null
    },
    tenantId: {
      type: String,
      default: () => null
    },
    startTime: {
      type: String,
      default: () => '2024-04'
    },
    endTime: {
      type: String,
      default: () => '2025-03'
    }
  },
  watch: {
    tenantId () {
      this.updateMaker()
    },
    startTime () {
      this.updateMaker()
    },
    endTime () {
      this.updateMaker()
    },
    mapchange (value) {
      if (value === '1') {
        this.destroyTdtMap()
        this.scheduleGoogleMapRefresh()
        return
      }
      if (value === '2') {
        this.refreshTdtView()
      }
    }
  },
  computed: {
    bikechange () {
      return [
        { value: '', label: this.$t('public.name19') },
        { value: 0, label: this.$t('map.name1') },
        { value: 1, label: this.$t('map.name2') },
        { value: 2, label: this.$t('home.name30') }
      ]
    },
    bikechangestatustype () {
      return [
        { value: 0, label: this.$t('map.name3') },
        { value: 1, label: this.$t('map.name4') },
        { value: 2, label: this.$t('map.name5') }
      ]
    },
    bikechangehour () {
      return [
        { value: 12, label: this.$t('map.name6') },
        { value: 24, label: this.$t('map.name7') },
        { value: 36, label: this.$t('map.name8') },
        { value: 48, label: this.$t('map.name9') }
      ]
    }
  },
  data () {
    return {
      datassss: [],
      // 缺省来自 flavor：国内 '2'(tdt) / 海外 '1'(google)；用户仍可切换
      mapchange: defaultMapChange,
      centergoole: { ...DEFAULT_MAP_CENTER },
      queryInfo: {
        status: '',
        statustype: 0,
        hour: 24
      },
      // goole
      hotmarkersgoole: [],
      infoWindowPosgoole: null,
      infoWinOpengoole: false,
      currentMidxgoole: null,
      infoOptionsgoole: {
        content: '',
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      zoom: 8,
      status: '',
      markersgoole: [],
      // baidu
      hotmarkersbaidu: [],
      infoWindowPosbaidu: null,
      infoWinOpenbaidu: false,
      currentMidxbaidu: null,
      markersbaidu: [],
      infoOptionsbaidu: { content: '' },
      centerbaidu: { ...DEFAULT_MAP_CENTER },
      tMap: null,
      heatmapOverlay: null,
      T: null
    }
  },
  created () {
    this.updateMaker()
  },
  mounted () {
    if (this.mapchange === '1') {
      this.scheduleGoogleMapRefresh()
    } else if (this.mapchange === '2') {
      this.refreshTdtView()
    }
  },
  beforeDestroy () {
    this.destroyTdtMap()
  },
  methods: {
    buildMapInfoText (item) {
      return '<div><span>' + this.$t('map.name11') + ' :</span>' + escapeHtml(item.ebikeId) + '</div>' +
        '<div><span>' + this.$t('bike.name165') + '</span>' + escapeHtml(item.mac) + '</div>' +
        '<div><span>' + this.$t('map.name12') + ' :</span>' + escapeHtml(item.lockStatus) + '</div>' +
        '<div><span>' + this.$t('bike.name141') + ' :</span>' + escapeHtml(item.speed) + '</div>' +
        '<div><span>' + this.$t('home.name26') + ' :</span>' + escapeHtml(item.soc) + '</div>' +
        '<div><span>' + this.$t('home.name27') + ' :</span>' + escapeHtml(item.status) + '</div>' +
        '<div><span>' + this.$t('bike.name169') + '</span>' + escapeHtml(item.lng) + '</div>' +
        '<div><span>' + this.$t('bike.name170') + '</span>' + escapeHtml(item.lat) + '</div>' +
        '<div><span>' + this.$t('bike.name171') + '</span>' + escapeHtml(item.alt) + '</div>' +
        '<div><span>' + this.$t('bike.name167') + '</span>' + escapeHtml(item.gisTime) + '</div>' +
        '<div><span>' + this.$t('bike.name110') + ' :</span>' + escapeHtml(item.remark) + '</div>'
    },
    handleMap ({ BMap, map }) {
      // this.map = map
      // this.BMap = BMap
      // this.updateMaker()
    },
    onGoogleHeatMapReady () {
      this.scheduleGoogleMapRefresh()
    },
    // 等 Google Map 实例就绪且容器有尺寸后再 resize，避免瓦片只铺一角
    scheduleGoogleMapRefresh (attempt = 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.mapchange !== '1') return
          if (this.refreshGoogleMapView()) return
          if (attempt < 10) {
            this.scheduleGoogleMapRefresh(attempt + 1)
          }
        }, attempt === 0 ? 80 : 160)
      })
    },
    refreshGoogleMapView () {
      const heatMap = this.$refs.googleHeatMap
      if (heatMap && typeof heatMap.refreshMapView === 'function') {
        return heatMap.refreshMapView() === true
      }
      return false
    },
    // 对齐实时监控 +/-：Google 走 HeatMap.changeZoom，天地图走 T.Map zoomIn/zoomOut
    changeMapZoom (delta) {
      if (this.mapchange === '1') {
        const heatMap = this.$refs.googleHeatMap
        if (heatMap && typeof heatMap.changeZoom === 'function') {
          heatMap.changeZoom(delta)
        }
        return
      }
      if (this.mapchange === '2' && this.tMap) {
        if (delta > 0 && typeof this.tMap.zoomIn === 'function') {
          this.tMap.zoomIn()
        } else if (delta < 0 && typeof this.tMap.zoomOut === 'function') {
          this.tMap.zoomOut()
        } else if (typeof this.tMap.getZoom === 'function' && typeof this.tMap.setZoom === 'function') {
          const current = Number(this.tMap.getZoom()) || 4
          this.tMap.setZoom(Math.min(18, Math.max(1, current + delta)))
        }
      }
    },
    // 对齐实时监控：等容器有尺寸后再 init，并 checkResize，避免天地图瓦片显示不全
    refreshTdtView (attempt = 0) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.mapchange !== '2') return
          if (this.initTdtMap()) {
            this.setMapOverlay()
            return
          }
          if (attempt < 6) {
            this.refreshTdtView(attempt + 1)
          }
        }, attempt === 0 ? 80 : 180)
      })
    },
    initTdtMap () {
      if (!window.T) return false
      const container = document.getElementById('dataOverviewMapDiv')
      if (!container) return false
      if (container.offsetWidth === 0 || container.offsetHeight === 0) return false

      // v-if 切走 Google 后 DOM 会重建，旧 map 实例已失效
      if (this.tMap && !container.childNodes.length) {
        this.destroyTdtMap()
      }

      this.T = window.T
      if (!this.tMap) {
        this.tMap = new this.T.Map('dataOverviewMapDiv')
        this.heatmapOverlay = new this.T.HeatmapOverlay({ radius: 30 })
      }
      if (typeof this.tMap.checkResize === 'function') {
        this.tMap.checkResize()
      }
      return true
    },
    destroyTdtMap () {
      this.tMap = null
      this.heatmapOverlay = null
    },
    computeMapCenter (points) {
      return computeDenseClusterView(points).center
    },
    async updateMaker () {
      this.markersgoole = []
      this.markersbaidu = []
      this.hotmarkersgoole = []
      this.hotmarkersbaidu = []
      const data = {
        tenantType: this.tenantType,
        tenantId: this.tenantId,
        startTime: this.startTime,
        endTime: this.endTime
      }
      getEbikeMap(data)
        .then((res) => {
          const iotEbikeProfileList = []
          res.data.map((item) => {
            if (item.lat && item.lng) {
              iotEbikeProfileList.push(item)
            }
          })
          if (iotEbikeProfileList.length > 0) {
            iotEbikeProfileList.forEach((item) => {
              // 国内 GCJ02，海外 WGS84；统一由 toMapLngLat 决定
              const pt = toMapLngLat(Number(item.lng), Number(item.lat), 'google')
              if (!pt) return
              this.hotmarkersgoole.push({
                lng: pt.lng,
                lat: pt.lat
              })
              this.markersgoole.push({
                ebikeId: item.ebikeId,
                position: {
                  lng: pt.lng,
                  lat: pt.lat
                },
                infoText: this.buildMapInfoText(item)
              })
            })
            this.centergoole = this.computeMapCenter(this.hotmarkersgoole)
            iotEbikeProfileList.forEach((item) => {
              // const bikepointbaidu = coordtransform.wgs84togcj02(item.lng, item.lat)
              // const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
              this.hotmarkersbaidu.push({
                lng: item.lng,
                lat: item.lat,
                count: 30
              })
              this.markersbaidu.push({
                ebikeId: item.ebikeId,
                position: {
                  lng: item.lng,
                  lat: item.lat
                },
                infoText: this.buildMapInfoText(item)
              })
            })
            this.centerbaidu = this.computeMapCenter(this.hotmarkersbaidu)

            if (this.mapchange === '2') {
              this.refreshTdtView()
            } else if (this.mapchange === '1') {
              this.scheduleGoogleMapRefresh()
            }
          } else {
            // this.$message({
            //   message: '没有该类型的数据',
            //   type: 'error'
            // })
          }
        })
        .catch(() => { })
      // const iotEbikeProfileList = [
      //   {
      //     lng: '119.056013',
      //     lat: '31.668381',
      //     ebikeId: '',
      //     mac: '',
      //     lockStatus: '开锁',
      //     speed: '800',
      //     soc: '',
      //     status: '',
      //     alt: '41.3',
      //     gisTime: '2025-03-10 16:57:27',
      //     remark: '111'
      //   },
      //   {
      //     lng: '119.055990',
      //     lat: '31.668401',
      //     ebikeId: '',
      //     mac: '',
      //     lockStatus: '开锁',
      //     speed: '800',
      //     soc: '',
      //     status: '',
      //     alt: '43.5',
      //     gisTime: '2025-03-10 16:59:53',
      //     remark: '111'
      //   }
      // ]
      // } else if (this.queryInfo.statustype === 1) {
      //   const res = await this.$API.bikelist.reqfindAuthEbikeGisProfileList({ status: this.queryInfo.status })
      //   if (res.result.data.iotEbikeProfileList) {
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       if (this.chinascope(item.lng, item.lat) === true) {
      //         const bikepoint = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoint[0]),
      //           lat: Number(bikepoint[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(bikepoint[0]),
      //             lat: Number(bikepoint[1])
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       } else {
      //         const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoints[0]),
      //           lat: Number(bikepoints[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(item.lng),
      //             lat: Number(item.lat)
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       }
      //     })
      //     this.centergoole = {
      //       lat: this.markersgoole[0].position.lat,
      //       lng: this.markersgoole[0].position.lng
      //     }
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       const bikepointbaidu = coordtransform.wgs84togcj02(item.lng, item.lat)
      //       const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
      //       this.hotmarkersbaidu.push({
      //         lng: Number(bikepointsbaidu[0]),
      //         lat: Number(bikepointsbaidu[1]),
      //         count: 30
      //       })
      //       this.markersbaidu.push({
      //         ebikeId: item.ebikeId,
      //         position: {
      //           lng: Number(bikepointsbaidu[0]),
      //           lat: Number(bikepointsbaidu[1])
      //         },
      //         infoText:
      //           '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //           '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //           '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //           '<div><span>速度 :</span>' + item.speed + '</div>' +
      //           '<div><span>电量 :</span>' + item.soc + '</div>' +
      //           '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //           '<div><span>经度 :</span>' + item.lng + '</div>' +
      //           '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //           '<div><span>高度 :</span>' + item.alt + '</div>' +
      //           '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //           '<div><span>备注 :</span>' + item.remark + '</div>'
      //       })
      //     })
      //     this.centerbaidu = {
      //       lat: this.markersbaidu[0].position.lat,
      //       lng: this.markersbaidu[0].position.lng
      //     }
      //   } else {
      //     this.$message({
      //       message: '没有该类型的数据',
      //       type: 'error',
      //       offset: 60
      //     })
      //   }
      // } else if (this.queryInfo.statustype === 2) {
      //   const res = await this.$API.bikelist.reqfindEbikeAllGisProfileList({ status: this.queryInfo.status })
      //   if (res.result.data.iotEbikeProfileList) {
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       if (this.chinascope(item.lng, item.lat) === true) {
      //         const bikepoint = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoint[0]),
      //           lat: Number(bikepoint[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(bikepoint[0]),
      //             lat: Number(bikepoint[1])
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       } else {
      //         const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
      //         this.hotmarkersgoole.push({
      //           lng: Number(bikepoints[0]),
      //           lat: Number(bikepoints[1])
      //         })
      //         this.markersgoole.push({
      //           ebikeId: item.ebikeId,
      //           position: {
      //             lng: Number(item.lng),
      //             lat: Number(item.lat)
      //           },
      //           infoText:
      //             '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //             '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //             '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //             '<div><span>速度 :</span>' + item.speed + '</div>' +
      //             '<div><span>电量 :</span>' + item.soc + '</div>' +
      //             '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //             '<div><span>经度 :</span>' + item.lng + '</div>' +
      //             '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //             '<div><span>高度 :</span>' + item.alt + '</div>' +
      //             '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //             '<div><span>备注 :</span>' + item.remark + '</div>'
      //         })
      //       }
      //     })
      //     this.centergoole = {
      //       lat: this.markersgoole[0].position.lat,
      //       lng: this.markersgoole[0].position.lng
      //     }
      //     res.result.data.iotEbikeProfileList.forEach((item) => {
      //       const bikepointbaidu = coordtransform.wgs84togcj02(item.lng, item.lat)
      //       const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
      //       this.hotmarkersbaidu.push({
      //         lng: Number(bikepointsbaidu[0]),
      //         lat: Number(bikepointsbaidu[1]),
      //         count: 30
      //       })
      //       this.markersbaidu.push({
      //         ebikeId: item.ebikeId,
      //         position: {
      //           lng: Number(bikepointsbaidu[0]),
      //           lat: Number(bikepointsbaidu[1])
      //         },
      //         infoText:
      //           '<div><span>车辆编号 :</span>' + item.ebikeId + '</div>' +
      //           '<div><span>车辆mac :</span>' + item.mac + '</div>' +
      //           '<div><span>车锁的状态 :</span>' + item.lockStatus + '</div>' +
      //           '<div><span>速度 :</span>' + item.speed + '</div>' +
      //           '<div><span>电量 :</span>' + item.soc + '</div>' +
      //           '<div><span>车辆状态 :</span>' + item.status + '</div>' +
      //           '<div><span>经度 :</span>' + item.lng + '</div>' +
      //           '<div><span>纬度 :</span>' + item.lat + '</div>' +
      //           '<div><span>高度 :</span>' + item.alt + '</div>' +
      //           '<div><span>轨迹时间 :</span>' + item.gisTime + '</div>' +
      //           '<div><span>备注 :</span>' + item.remark + '</div>'
      //       })
      //     })
      //     this.centerbaidu = {
      //       lat: this.markersbaidu[0].position.lat,
      //       lng: this.markersbaidu[0].position.lng
      //     }
      //   } else {
      //     this.$message({
      //       message: '没有该类型的数据',
      //       type: 'error',
      //       offset: 60
      //     })
      //   }
      // }
    },
    setMapOverlay () {
      if (!this.tMap || !this.T || !this.heatmapOverlay) return
      // 与谷歌 HeatMap 共用：按网格主聚集区定中心与 zoom，避免固定 zoom=4 看不见热力
      const view = computeDenseClusterView(this.hotmarkersbaidu)
      this.centerbaidu = { ...view.center }
      this.tMap.centerAndZoom(
        new this.T.LngLat(view.center.lng, view.center.lat),
        view.suggestedZoom
      )
      this.tMap.clearOverLays()
      this.tMap.addOverLay(this.heatmapOverlay)
      this.heatmapOverlay.setDataSet({ data: this.hotmarkersbaidu, max: 300 })
      if (typeof this.tMap.checkResize === 'function') {
        this.tMap.checkResize()
      }
    },
    async infowindowgoole (marker, idx) {
      const res = await this.$API.bikelist.reqgetEbikeEmail({
        ebikeId: marker.ebikeId
      })
      if (res.result.code !== 200) {
        return this.$message.error(res.result.errorMsg)
      }
      this.infoWindowPosgoole = marker.position
      this.infoOptionsgoole.content = marker.infoText + '<div><span>' + this.$t('map.name10') + ' :</span>' + escapeHtml(res.result.data.email) + '</div>'
      this.centergoole = {
        lat: marker.position.lat,
        lng: marker.position.lng
      }
      if (this.currentMidxgoole === idx) {
        this.infoWinOpengoole = !this.infoWinOpengoole
      } else {
        this.infoWinOpengoole = true
        this.currentMidxgoole = idx
      }
    },
    async infowindowbaidu (marker, idx) {
      const res = await this.$API.bikelist.reqgetEbikeEmail({
        ebikeId: marker.ebikeId
      })
      if (res.result.code !== 200) {
        return this.$message.error(res.result.errorMsg)
      }
      this.infoWindowPosbaidu = marker.position
      this.infoOptionsbaidu.content = marker.infoText + '<div><span>' + this.$t('map.name10') + ' :</span>' + escapeHtml(res.result.data.email) + '</div>'
      this.centerbaidu = {
        lat: marker.position.lat,
        lng: marker.position.lng
      }
      if (this.currentMidxbaidu === idx) {
        this.infoWinOpenbaidu = !this.infoWinOpenbaidu
      } else {
        this.infoWinOpenbaidu = true
        this.currentMidxbaidu = idx
      }
    }
  }
}

</script>
<style lang="scss">
.el-radio {
  font-weight: 800 !important;
}
</style>
<style lang="scss" scoped>
.rl-map {
  width: 50%;
  position: relative;
  min-width: 0;
  flex: 1 1 50%;
}

.map-type {
  position: absolute;
  left: 48px;
  top: 10px;
  display: flex;
  flex-direction: row;
  z-index: 1000;
  font-weight: 800;
  align-items: center;
}

.map {
  width: 100%;
  height: calc(100vh - 360px);
}

.bm-view {
  width: 100%;
  height: calc(100vh - 360px) !important;
}

.google-map-wrap {
  position: relative;
  overflow: hidden;
}

.tdt-map-wrap {
  position: relative;
  width: 100%;
}

/* 对齐实时监控：+/- 放数据总览左上角 */
.map-zoom-controls {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  pointer-events: auto;

  .map-zoom-btn {
    width: 29px;
    height: 29px;
    padding: 0;
    border: 1px solid #ccc;
    border-radius: 0;
    background: #fff;
    color: #333;
    font-size: 18px;
    line-height: 27px;
    cursor: pointer;

    &:first-child {
      border-bottom: none;
    }

    &:hover {
      background: #f5f5f5;
    }
  }
}
</style>
